// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__eAeet","title":"Info_title__1xhBM","links":"Info_links__2cbXm","link":"Info_link__2wUQw","logo":"Info_logo__-ZXCe"};